import Flex from 'components/Flex'
import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: ${props => props?.mTop};
`
export const LeftSection = styled(Flex)`
  gap: 20px;
  flex-wrap: wrap;
`

export const StyledButton1 = styled.button`
  width: 159px;
  height: 38px;
  top: 308px;
  left: 250px;
  gap: 0px;
  border-radius: 22px 22px;
  border: 1px solid rgba(214, 219, 247, 1);
  cursor: pointer;
  background-color: ${props =>
    props.isSelected ? ' #3249D7' : 'rgba(255, 255, 255, 1)'};
  color: ${props => (props.isSelected ? 'white' : 'black')};
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: ${props => (props.isSelected ? ' 800' : '400')};
  line-height: 18px;
  text-align: center;
  box-shadow: 0px 2px 6px 0px rgba(123, 97, 255, 0.15);
`
export const SectionWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`
export const RightSection = styled(Flex)`
  display: flex;

  justify-content: flex-end;
`
export const date = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`
